// Hari K:08-11-2023 :BT-119138:Funds View - withdraw funds modal-start

import { forwardRef, memo, useEffect, useMemo, useState } from "react";
import { BzButton, BzChip, BzInputText, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../components";
import { Row, Col, Container, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { handleModal, handleModalData } from "../../redux/actions/modals";
import { getFundsWithdrawal } from "../../redux/actions/funds";
import { _commaFormatter, _kFormatter } from "../../controllers";
import { checkFundsConfigConditions, getAppInfoData } from "../../utils/global_functions";
import { APP_INFO_PARAMS, FUNDS_CONFIG_KEYS } from "../../utils/global_variables";
import { toastConfig } from "../../redux/actions/toast";
import { _GetPGDownTime } from "../../controllers/funds";


const WithDrawalModal = ({ activeMarket, setActiveMarket, }) => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const productWiseBalance = useSelector(state => state.funds.allowedMarkets);
    const bankAccList = useSelector(state => state.funds.bankAccList);
    const data = getAppInfoData(APP_INFO_PARAMS.APP_FUNDS_CONFIG);
    const fundsConfig = Array.isArray(data) ? data[0] : data;
    const dicTrHolidayMaster = useSelector(state => state.funds.dicTrHolidayMaster);
    const objFundsMaxAmount = getAppInfoData(APP_INFO_PARAMS.APP_FUND_MAX_AMT);
    const bankSelectOption = getAppInfoData(APP_INFO_PARAMS.APP_HIDE_FWBANK_SELECTION_OPTION);
    const reserveAmount = getAppInfoData(APP_INFO_PARAMS.APP_RESERVE_BLOCK_FROM_ALLOCATION_FUND_SETTINGS_ABSOLUTE); // Hari k:2023-12-20 taking the values from app info to show available withdrawal amount
    const [withdrawInputs, setWithdrawInputs] = useState({ addAmount: "", bankDetails: {} });
    const [isSatisfiedAllparameters, setIsSatisfiedAllparameters] = useState(true);
    const [selectedBankAccount, setSelectedBankAccount] = useState([]);
    const [objDowntime, setobjDowntime] = useState();
    const PGDownKeys = getAppInfoData(APP_INFO_PARAMS.APP_WAVE_SETTING); // Hari K:22-02-2023 :BT-119138:Funds View to get down time key values from mobile admin

    // const nMaxInputLength = objFundsMaxAmount?.withdraw ? objFundsMaxAmount?.withdraw?.length : FUNDS_DEFAULT_INPUT_LENGTH.WITHDRAWAL_FUNDS;
    useEffect(() => {
        if (bankAccList?.length) {
            const productWiseBankDetails = bankAccList?.filter((eachAccount) => eachAccount?.nProductCode === activeMarket?.sProductId || eachAccount?.nProductCode === '0');
            if (productWiseBankDetails?.length) {
                setSelectedBankAccount(productWiseBankDetails);
                setWithdrawInputs({ ...withdrawInputs, bankDetails: productWiseBankDetails[0] });
            } else {
                setSelectedBankAccount([]);
                setWithdrawInputs({ ...withdrawInputs, bankDetails: {} });
            }

        } else { }
    }, [bankAccList, activeMarket]);

    const handleOrderInputs = (amount) => {
        setWithdrawInputs({ ...withdrawInputs, addAmount: amount });
    };

    useEffect(() => {
        if (withdrawInputs?.addAmount > 0 && activeMarket && Object.keys(activeMarket)?.length && objDowntime?.IsDownTime === false && Object.keys(withdrawInputs?.bankDetails).length > 0) {
            setIsSatisfiedAllparameters(false);
        } else {
            setIsSatisfiedAllparameters(true);
        }
    }, [activeMarket, withdrawInputs]);

    // Hari K:22-02-2023 :BT-119138:Funds View-to check down time for withdrawal funds-start
    useEffect(() => {
        if (dicTrHolidayMaster?.length) {
            _GetPGDownTime(PGDownKeys, dicTrHolidayMaster, "FW", dispatch).then((response) => {
                setobjDowntime(response);
            });
        }
    }, [dicTrHolidayMaster]);
    // Hari K:22-02-2023 :BT-119138:Funds View-to check down time for withdrawal funds-start

    const handleSubmitButton = () => {
        setIsSatisfiedAllparameters(true);
        if (withdrawInputs?.addAmount > 0 && Object.keys(activeMarket)?.length) {
            if (!(Number(withdrawInputs?.addAmount) > (reserveAmount !== undefined && reserveAmount !== null ? Number(activeMarket?.balanceAmount) - Number(reserveAmount) : Number(activeMarket?.balanceAmount)))) {
                if (Number(withdrawInputs?.addAmount) <= Number(objFundsMaxAmount?.withdraw) || !objFundsMaxAmount?.withdraw) {
                    const appWithdrawKey = getAppInfoData(APP_INFO_PARAMS.FUNDS_WITHDRAW) || "1";
                    let objPayload = {
                        "amount": withdrawInputs?.addAmount,
                        "productId": activeMarket?.sProductId,
                        "bankId": withdrawInputs?.bankDetails?.sBankId,
                        "accNo": withdrawInputs?.bankDetails?.sAccountNo,
                        "productName": activeMarket?.sProductName,
                        "appWithdrawKey": appWithdrawKey,     // Abhi V:15092025 changes for key based request transfer to webadmin or pgadmin
                    };
                    dispatch(getFundsWithdrawal(objPayload))?.then(() => {
                        setIsSatisfiedAllparameters(false);
                        setWithdrawInputs({ ...withdrawInputs, addAmount: "" });
                        dispatch(handleModal([{ "SUCCESS_MODAL": true }]));
                        dispatch(handleModalData({ transactionType: "FW" }));
                        dispatch(handleModal([{ "WITHDRAW_MODAL": false }]));
                    })?.catch((error) => {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `Ooop!! Please try again...` }));
                        setIsSatisfiedAllparameters(false);
                    });
                } else {
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: `Please enter Amount between 0 to ${Number(objFundsMaxAmount?.withdraw)}` }));
                }
            } else {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: `Withdrawal request is greater than the available funds` }));
            }
        } else { }
    };
    const handleClose = () => {
        setWithdrawInputs({ addAmount: "", ...withdrawInputs });
        setIsSatisfiedAllparameters(true);
        dispatch(handleModal([{ "WITHDRAW_MODAL": false }]));
    };
    const handleProductChange = (value) => {
        setActiveMarket(value);
    };
    const handleBankChange = (selectedBank) => {
        setWithdrawInputs({ ...withdrawInputs, bankDetails: selectedBank });
    };

    const CustomDropdownToggle = forwardRef(({ children, onClick }, ref) => (
        <div
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
        >
            {children}
        </div>
    ));

    const availableFunds = useMemo(() => {
        if (withdrawInputs?.addAmount >= 0 && activeMarket && Object.keys(activeMarket)?.length) {
            return Number(activeMarket?.balanceAmount) - Number(withdrawInputs?.addAmount);
        } else { }
    }, [activeMarket, withdrawInputs, productWiseBalance]);




    return (
        /*SumitG-08-12-23*/
        <Container fluid className='p-0'>
            <BzModal show={modals['WITHDRAW_MODAL']} onHide={handleClose} centered data-testid='funds-withdrawal-modal'>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={10} className='d-flex justify-content-start align-items-center add-funds-dropdown-wrapper'>
                                <Dropdown data-testid='funds-withdrawal-modal-product-dropdown'>
                                    <Dropdown.Toggle as={CustomDropdownToggle}>
                                        <div className='d-flex justify-content-start align-items-center'>
                                            <div data-testid='funds-withdrawal-modal-seleted-product' className='font-medium font-size3 color-text'>{activeMarket?.sProductName} (Balance: ₹ {_commaFormatter(_kFormatter(parseFloat(activeMarket?.balanceAmount)))})</div>
                                            <div data-testid='funds-withdrawal-modal-product-dropdown-icon' className='icon-20 icon-sort-down icon-dark ms-2'></div>
                                        </div>
                                    </Dropdown.Toggle>
                                    {productWiseBalance?.length > 0 ?
                                        <Dropdown.Menu data-testid='funds-withdrawal-modal-product-dropdown-menu'>
                                            {productWiseBalance && productWiseBalance?.length > 0 && productWiseBalance?.map((eachProduct, i) => (
                                                <Dropdown.Item data-testid={`funds-withdrawal-modal-product-dropdown-item-${i}`} key={i} onClick={() => { handleProductChange(eachProduct); }} value={eachProduct.sProductId}>{eachProduct?.sProductName} (Balance: ₹{_commaFormatter(_kFormatter(parseFloat(eachProduct?.balanceAmount)))})</Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                        : null}
                                </Dropdown>
                            </Col>
                            <Col md={2} className='d-flex justify-content-end align-items-center'>
                                <div data-testid='funds-withdrawal-modal-close-icon' className='icon-16 icon-close icon-dark' onClick={handleClose}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <Row className='g-0 d-flex align-items-center'>
                            <Col md={4} className='pe-4'>
                                <div data-testid='funds-withdrawal-modal-withdraw-funds-label' className='font-medium font-size9 color-text text-wrap'>Withdraw <div className='break-line'>Funds</div></div>
                            </Col>
                            <Col md={8}>
                                <div className='input-group align-items-center add-funds-input'>
                                    <span className='font-medium font-size9 color-text me-1'>&#8377;</span>
                                    <BzInputText data-testid='funds-withdrawal-modal-add-amount-input' type="number" autoComplete='off' placeholder={0} value={withdrawInputs?.addAmount} name="add amount" className='text-start font-size9 p-0 form-control font-medium bdr-none' onChange={(e) => handleOrderInputs(e.target.value)} />
                                </div>
                                <div className='d-flex justify-content-start chips-wrap mt-2'>
                                    <BzChip data-testid='funds-withdrawal-modal-available-funds-chip' className='withdraw-fund-chip me-1 mb-1'><span className='font-medium'>Available funds  withdrawal: &#8377;{reserveAmount && !isNaN(reserveAmount) ? parseFloat(availableFunds) - parseFloat(reserveAmount) : availableFunds}</span> </BzChip>
                                </div>
                            </Col>
                        </Row>
                        {selectedBankAccount?.length ?
                            <Row className='g-0 pt-4'>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    <div data-testid='funds-withdrawal-modal-bank-account-text' className='font-regular font-size3 color-text me-2'>Funds will be deposited in your linked account</div>
                                    {bankSelectOption !== "ON" ? <div className='d-flex justify-content[-start align-items-center add-funds-dropdown-wrapper'>
                                        <Dropdown data-testid='funds-withdrawal-modal-bank-account-dropdown'>
                                            <Dropdown.Toggle as={CustomDropdownToggle}>
                                                <div className='d-flex justify-content-start align-items-center'>
                                                    <div className='font-medium font-size3 color-text'>{withdrawInputs?.bankDetails?.sBankId} XXX{withdrawInputs?.bankDetails?.sAccountNo?.slice(-4)}</div>
                                                    {selectedBankAccount?.length > 1 ? <div data-testid='funds-withdrawal-modal-bank-account-dropdown-icon' className='icon-20 icon-sort-down icon-dark ms-2'></div> : null}
                                                </div>
                                            </Dropdown.Toggle>
                                            {selectedBankAccount?.length > 1 ?
                                                <Dropdown.Menu>
                                                    {selectedBankAccount?.length && selectedBankAccount?.map((eachBank) => (
                                                        <Dropdown.Item data-testid={`funds-withdrawal-modal-bank-account-dropdown-item-${eachBank?.sAccountNo}`} key={eachBank?.sAccountNo} onClick={() => { handleBankChange(eachBank); }} value={eachBank.sAccountNo}>{eachBank?.sBankId}XXX{eachBank?.sAccountNo?.slice(-4)}</Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                                : null}
                                        </Dropdown>
                                    </div> : null}
                                </Col>
                            </Row> : null}
                        {    /* Hari K:22-02-2023 :BT-119138:Funds Viev-to show show down time message-start*/}
                        {objDowntime?.IsDownTime ?
                            <Row className='g-0 pt-4'>
                                <Col md={1} className='d-flex justify-content-center'>
                                    <div className='icon-16 icon-info icon-negative'></div>
                                </Col>
                                <Col md={11}>
                                    <div data-testid='funds-withdrawal-modal-downtime-message' className='font-regular font-size2 color-error'>{objDowntime?.PGDowntimeMsg}</div>
                                </Col>
                            </Row>
                            : null}
                        {    /* Hari K:22-02-2023 :BT-119138:Funds Viev-to show show down time message-end*/}

                        <Row className='g-0'>
                            <Col>
                                <div>&nbsp;</div>
                                <div>&nbsp;</div>
                                <div>&nbsp;</div>
                                <div>&nbsp;</div>
                                <div>&nbsp;</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalBody>
                <BzModalFooter className='bdr-none'>
                    <Container fluid className='p-0 m-0'>

                        {fundsConfig?.FWdisclaimer ?
                            <Row className='g-0 py-2 mb-2'>
                                <Col className='d-flex justify-content-center'>
                                    <div data-testid='funds-withdrawal-modal-disclaimer-text' className='font-regular font-size2 color-text'><span>Note:</span>{fundsConfig?.FWdisclaimer}</div>
                                </Col>
                            </Row> : null}
                        <Row className='g-0'>
                            <Col>
                                <BzButton data-testid='funds-withdrawal-modal-request-withdrawal-button' className='btn btn-md btn-primary btn-block' disabled={isSatisfiedAllparameters} onClick={handleSubmitButton} >Requesting for Withdrawal</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>
        </Container>
    );
};

export default memo(WithDrawalModal);
// Hari K:08-11-2023 :BT-119138:Funds View - withdraw funds modal-end